<div class="row">
	<div class="col-sm-12">
		<div class="content-header" *ngIf="!isOnboarding">Onboarding Form</div>
		<div class="content-header" *ngIf="isOnboarding">Onboarding Details</div>
	</div>
  </div>
  <section id="ngx" *ngIf="!isOnboarding || currentUrl ==='onboarding-form'">
	<div class="card">
		<div class="card-content">
			<div class="card-body">
  
				<aw-wizard #wizard [navBarLayout]="'large-empty-symbols'">
					<aw-wizard-step [stepTitle]="'Step 1'" [navigationSymbol]="{ symbol: '&#xf007;', fontFamily: 'FontAwesome' }">
						
						<form [formGroup]="basicForm" (ngSubmit)="onBasicFormSubmit()">
							
							<div class="row justify-content-center my-4">
							  <div class="col-6 form-group">
								<label for="title">About<span class="required_field">*</span></label>
								<div class="controls">
									<textarea name="about"  formControlName="about" [(ngModel)]="onboarding_model.about" class="form-control" id="about" cols="30" rows="8" placeholder="Enter About (at least 50 characters)" required [ngClass]="{ 'is-invalid': basicForm && bf.about.invalid, 'is-valid': basicForm && !bf.about.invalid }"></textarea>
									  <div *ngIf="basicForm && (bf.about.invalid || bf.about.errors?.required)"
										class="help-block mt-1 text-danger"> <i class="ft-alert-circle align-middle"></i> This is
										required</div>
								</div>
							  </div>
							  
							  <div class="col-12 d-flex flex-sm-row flex-column justify-content-end">
								<button [disabled]="!basicForm.valid" type="submit" class="btn btn-primary mr-sm-2 mb-1" awNextStep >Next</button>
							  </div>
							</div>
						  </form>
					</aw-wizard-step>
					
					<aw-wizard-step [stepTitle]="'Step 2'" [navigationSymbol]="{ symbol: '&#xf0ac;', fontFamily: 'FontAwesome' }">
						<form [formGroup]="basicForm3" (ngSubmit)="onBasicFormSubmit3()">
							<div class="row justify-content-center my-4">
								<div class="col-6 form-group">
									<label for="title">Resume<span class="required_field">*</span></label>
									<div class="controls">
									  <input type="text" formControlName="resume" [(ngModel)]="onboarding_model.resume" class="form-control" placeholder="resume"
										[ngClass]="{ 'is-invalid': basicFormSubmitted3 && bf3.resume.invalid, 'is-valid': basicFormSubmitted3 && !bf3.resume.invalid }"
										required>
									  <div *ngIf="basicFormSubmitted3 && (bf3.resume.invalid || bf3.resume.errors?.required)"
										class="help-block mt-1 text-danger"> <i class="ft-alert-circle align-middle"></i> This is
										required</div>
									</div>
								  </div>
								 
							  <div class="col-12 d-flex flex-sm-row flex-column justify-content-end">
								<button type="submit" class="btn btn-secondary mr-sm-2 mb-1" awPreviousStep>Previous</button>
								<button [disabled]="!basicForm3.valid"  type="submit" class="btn btn-primary mr-sm-2 mb-1"  awNextStep>next</button>
							  </div>
							</div>
						  </form>
  
					</aw-wizard-step>
					<aw-wizard-step [stepTitle]="'Step 3'" [navigationSymbol]="{ symbol: '&#xf0ac;', fontFamily: 'FontAwesome' }">
						<form [formGroup]="basicForm4" (ngSubmit)="onBasicFormSubmit4()">
							<div class="row justify-content-center my-4">
								  <div class="col-6 form-group">
									<label for="title">LinkedIn<span class="required_field">*</span></label>
									<div class="controls">
									  <input type="text" formControlName="linkedIn" [(ngModel)]="onboarding_model.linkedIn" class="form-control" placeholder="linkedIn"
										[ngClass]="{ 'is-invalid': basicFormSubmitted4 && bf4.linkedIn.invalid, 'is-valid': basicFormSubmitted4 && !bf4.linkedIn.invalid }"
										required>
									  <div *ngIf="basicFormSubmitted4 && (bf4.linkedIn.invalid || bf4.linkedIn.errors?.required)"
										class="help-block mt-1 text-danger"> <i class="ft-alert-circle align-middle"></i> This is
										required</div>
									</div>
								  </div>
								  <div class="col-6 form-group">
									<label>Student Empowerment</label>
									<div class="controls">
										<mat-slide-toggle color="primary" [checked]="onboarding_model.is_interested"
										  (change)="onboarding_model.is_interested = !onboarding_model.is_interested">Are you interested ?</mat-slide-toggle>
									</div>
								  </div>
							  <div class="col-12 d-flex flex-sm-row flex-column justify-content-end">
								<button type="submit" class="btn btn-secondary mr-sm-2 mb-1" awPreviousStep>Previous</button>
								<button [disabled]="!basicForm4.valid" type="submit" class="btn btn-primary mr-sm-2 mb-1" (click)="submit()" awResetWizard>Finish</button>
							  </div>
							</div>
						  </form>
  
					</aw-wizard-step>
				</aw-wizard>
  
  
			</div>
		</div>
	</div>
  </section>

  <section *ngIf="isOnboarding && onboarding_model?._id && currentUrl !=='onboarding-form'">
	<div class="img-container">
		<div>
			<img  src="assets/img/no_logo_found.jpeg" alt="profile-img" class="rounded mr-3" height="64" width="64">
		</div>
		<button  *ngIf="onboarding_model.status!==''" class="btn btn-primary edit-btn" [disabled]="onboarding_model.status ==='approved'" (click)="update(onboarding_model)">Update</button>
	</div>
		
		
	<table>
		<tr>
			<td><b>Name :</b></td>
			<td>&nbsp;{{onboarding_model?.student_id[0]?.name}}</td>
		</tr>
		<tr>
			<td><b>About :</b></td>
			<td>&nbsp;{{onboarding_model.about}}</td>
		</tr>
		<tr>
			<td><b>Resume :</b></td>
			<td>&nbsp;{{onboarding_model.resume}}</td>
		</tr>
		<tr>
			<td><b>LinkedIn :</b></td>
			<td>&nbsp;{{onboarding_model.linkedIn}}</td>
		</tr>
	</table>
  </section>
  